<ion-list>
  <ion-item *ngFor="let p of options" lines="none" (click)="navigate(p.url)" button="true">
    <ion-label>{{p.title}}</ion-label>
  </ion-item>
</ion-list> 